import { Flag } from 'redux/types/enums';

export default function isFlagRequest(flag: Flag | unknown): boolean {
  return flag === Flag.Request;
}
